import { IDropdownResponse } from '../models';

export const getBulkDownloadTestData = async (): Promise<IDropdownResponse[]> => {
  try {
    const data = [
      {
        value: 'test-pdf-1.pdf',
        description: 'Test PDF 1',
        shorthand: 'Test PDF 1'
      },
      {
        value: 'test-pdf-2.pdf',
        description: 'Test PDF 2',
        shorthand: 'Test PDF 2'
      },
      {
        value: 'test-pdf-3.pdf',
        description: 'Test PDF 3',
        shorthand: 'Test PDF 3'
      }
    ];
    return data;
  } catch (error: any) {
    console.log(error);
    return Promise.reject(error.response.data);
  }
};
